import React from "react";
import { MobileViewBtns } from "./mobileViewBtns";
import checkIcon from "assets/icons/checkIcon.svg";
import ideaIcon from "assets/icons/idea.svg";
import emailIcon from "assets/icons/email.svg";
import tick from "assets/images/tick.png";
import download from "assets/images/download.svg";
import kypImg from "assets/icons/kyp_pageImg.svg";
import kypHImg from "assets/icons/kypHImg.svg";
import kypCImg from "assets/icons/kypCImg.svg";
import Card from "components/common/Card";
import { ImpactCard } from "./ImpactCard";

const msgStyles: any = {
  Healthy: {
    container: "bg-[#E2FDF0] border-green-300 2xl:p-4 py-4 flex items-center gap-2",
    title: "text-[#2BA882] font-extrabold text-lg uppercase",
    message: "Based on your responses, there are no errors in your policy’s personal information.",
    icon: <img src={tick} alt="" />,
    extra: "Congratulations!",
    img: <img src={download} />
  },
  Critical: {
    container: "bg-[#FFE9E9] p-4 flex items-center gap-2",
    title: "text-[#E55454] font-extrabold text-lg uppercase",
    message: "Based on your responses, there are few critical errors in your policy’s personal information.",
    icon: "",
    extra: ""
  },
  "Needs Attention": {
    container: "bg-[#FFF1E9] py-2 flex items-center",
    title: "text-[#F78C4F] font-extrabold text-lg uppercase",
    message: "Based on your responses, there are few errors in your policy’s personal information.",
    icon: "",
    extra: ""
  }
};
interface Props {
  onCopy: () => void;
  onGmailShare: () => void;
  policyData: any;
  policyType: string;
  fromHospital?: boolean;
  policyTypeId?: boolean;
}

export const HeadingSmallScreen: React.FC<Props> = ({ onCopy, onGmailShare, policyData, policyType, fromHospital, policyTypeId }) => {
  const type = policyData?.ResultTitle;
  const style = msgStyles[type];

  return (
    <Card className="w-full">
      <div className=" flex gap-4 justify-center items-center my-8 w-full px-5">
        <img src={policyData?.ResultTitle === "Healthy" ? kypHImg : policyData?.ResultTitle === "CRITICAL" ? kypCImg : kypImg} alt="heading Img" className="w-32 lg:w-52 object-contain" />
        <div className="text-start sm:text-left">
          <p className="font-extrabold text-lg ">{policyData.PolicyHolderName}</p>
          <p className="font-bold text-sm ">{policyData.InsuranceCompanyName}</p>
          <p className={`text-xs font-medium `}>{policyData.PolicyName}</p>
        </div>
      </div>
      {policyTypeId && fromHospital ? null : (
        <div className={`${style?.container}  w-full flex flex-col justify-center items-center `}>
          {/* mobile view */}
          <div className="w-full flex justify-between items-center ">
            <span className={`${style?.title}`}>{type}</span>
            {style?.extra && (
              <span className="flex items-end mr-0 ">
                <span className="font-bold">{style?.img}</span>
              </span>
            )}
          </div>
          <span className="w-full text-start font-medium text-sm">{style?.message}</span>
        </div>
      )}
      {policyType === "864a375b-5fa7-49c7-9f39-2b1fda4674b5" && (
        <>
          <ImpactCard title="Health & Lifestyle" status={policyData?.qualityCheckContent[0].SubTitle} description={policyData?.qualityCheckContent[0].Description} score={policyData?.qualityCheckContent[0].Score} />
          <ImpactCard title="Financial & Occupation" status={policyData?.qualityCheckContent[1].SubTitle} description={policyData?.qualityCheckContent[1].Description} score={policyData?.qualityCheckContent[1].Score} />
          <ImpactCard title="Contact & Admin" status={policyData?.qualityCheckContent[2].SubTitle} description={policyData?.qualityCheckContent[2].Description} score={policyData?.qualityCheckContent[2].Score} />
        </>
      )}

      {policyData?.ResultTitle !== "Healthy" && (
        <div className={`flex flex-col items-center justify-between gap-4 w-full ${policyType !== "864a375b-5fa7-49c7-9f39-2b1fda4674b5" && "pt-4"}`}>
          {/* Left Section - Heading */}
          <div className="flex gap-4  flex-shrink-0 py-2  px-4 bg-[#F2F2F6] w-full items-center">
            <img src={checkIcon} alt="check" className="w-5 h-5" />
            <span className="font-bold text-lg ">Our Advice</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 pb-4 px-4 sm:pl-4">
            {/* Middle Section */}
            <div className="flex items-center gap-3 max-w-full sm:max-w-xs lg:ml-4">
              <img src={ideaIcon} alt="idea" className="w-8 md:w-11 h-auto flex-shrink-0" />
              <p className="text-sm md:text-[15px]">Protect yourself by notifying your insurance company of any discrepancies in your policy for a smooth claim experience</p>
            </div>

            {/* Right Section */}
            <div className="flex items-center gap-3 max-w-full sm:max-w-xs">
              <img src={emailIcon} alt="email" className="w-8 md:w-11 h-auto flex-shrink-0" />
              <p className="text-sm md:text-[15px]">
                Send the correct information to your insurer using your <span className="font-semibold">Registered Email ID</span>.
              </p>
            </div>
          </div>
          {policyData?.ResultTitle !== "Healthy" && <MobileViewBtns onCopy={onCopy} onGmailShare={onGmailShare} className="2xl:hidden xl:hidden " />}
        </div>
      )}
    </Card>
  );
};
